import { useEffect } from 'react';
import { getCurrentUser } from '../../store/auth/authSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { socket } from '../../utils/socket';

export const useAuth = () => {
    const auth = useAppSelector(state => state.auth);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!auth.isLoading && !auth.wasUserFetched && !auth.error) {
            dispatch(getCurrentUser());
        }
    }, [dispatch, auth]);

    // socket user room connection
    useEffect(() => {
        if (auth.authData) {
            socket.auth = { userId: auth.authData.id };
            socket.connect();
        }
    }, [auth.authData]);

    return auth;
};
